module.exports = __webpack_public_path__ + "media/images/pc/plans/inclusion_23-d10ca29bc47d61437e4015a62c12096c.png";